export default __webpack_public_path__ + "static/media/bg-2.eda6411d.png";